<template>
  <RegisterTemplate
    :title="$t('verificationStatus.ibtVerification.start.bwtTitle')"
    :activeTab="0"
    :tabs="[]"
    type="BankWireTransfer"
  >
    <SuccessForm
      :title="'verificationStatus.ibtVerification.start.bwtTitle'"
      :desc="`verificationStatus.ibtVerification.start.bwtDesc`"
      :lists="bankWireTransferLists"
      :primaryButtonLabel="'common.start'"
      :primaryButtonOnClick="
        () => {
          $router.push(RegisterRoutePath.ibtVerification);
        }
      "
  /></RegisterTemplate>
</template>

<script>
import SuccessForm from '@/components/register/registerForms/SuccessForm.vue';
import RegisterTemplate from '@/components/register/registerTemplate/RegisterTemplate.vue';
import { RegisterRoutePath } from '@/router/registerRoutes';

export default {
  name: 'BankWireTransfer',
  components: { SuccessForm, RegisterTemplate },
  created() {
    this.RegisterRoutePath = RegisterRoutePath;
    this.bankWireTransferLists = [
      {
        name: '1',
        title: 'verificationStatus.ibtVerification.start.bwtFaqTitle1',
        desc: `verificationStatus.ibtVerification.start.bwtFaqDesc1`
      },
      {
        name: '2',
        title: 'verificationStatus.ibtVerification.start.bwtFaqTitle2',
        desc: `verificationStatus.ibtVerification.start.bwtFaqDesc2`
      },
      {
        name: '3',
        title: 'verificationStatus.ibtVerification.start.bwtFaqTitle3',
        desc: `verificationStatus.ibtVerification.start.bwtFaqDesc3`
      }
    ];
  }
};
</script>
